import isEmpty from "lodash/isEmpty";
import { shouldSeeThreeUsersBucketAbTest } from "/services/ab-tests/three-users-bucket-ab-test-service";
import { isInClusterTest } from "../pricing-page/clusterized-pricing-page-service";
import BasePricingModelService from "./base-pricing-model-service";
import { MAX_TEAM_SIZE } from "constants/pricing";

export default class BucketsPricingModelService extends BasePricingModelService {
  shouldShowUserOptions() {
    return true;
  }

  getClusterUserOptions(options = {}) {
    const { clusterConfig, abTests, forcePricing, cookies } = options;
    const users_count_options = clusterConfig?.payments_view?.pricing?.users_count_options;
    if (!isEmpty(clusterConfig) && isInClusterTest(clusterConfig, { abTests, forcePricing, cookies })) {
      return users_count_options?.all_options;
    }
  }

  getDefaultUserOption(options = {}) {
    const clusterUserOptions = this.getClusterUserOptions(options);
    if (clusterUserOptions?.length > 0) return clusterUserOptions[0];
    if (shouldSeeThreeUsersBucketAbTest(options)) {
      // after a successful test, anyone who can see the three users bucket should see it as default.
      return "3";
    }
    return "5";
  }

  getUserOptions(options = {}) {
    const clusterUserOptions = this.getClusterUserOptions(options);
    if (clusterUserOptions?.length > 0) return clusterUserOptions;
    const userOptions = ["5", "10", "15", "20", "25", "30", "40", "50", "100", MAX_TEAM_SIZE];
    if (shouldSeeThreeUsersBucketAbTest(options)) userOptions.unshift("3");
    return userOptions;
  }

  getPrices({ pricingVersion }) {
    return {
      monthly: {
        basic: { usd: 10, euro: 10, gbp: 9, cad: 14, aud: 14, brl: 43, mxn: 200, inr: 750, jpy: 1100 },
        standard: { usd: 12, euro: 12, gbp: 11, cad: 17, aud: 17, brl: 55, mxn: 240, inr: 900, jpy: 1400 },
        pro: { usd: 20, euro: 20, gbp: 18, cad: 27, aud: 27, brl: 91, mxn: 400, inr: 1500, jpy: 2200 },
        enterprise: { usd: 46, euro: 46, gbp: 40, cad: 62, aud: 62, brl: 217, mxn: 920, inr: 3450, jpy: 4700 }
      },
      yearly: {
        basic: { usd: 8, euro: 8, gbp: 7, cad: 11, aud: 11, brl: 35, mxn: 160, inr: 600, jpy: 900 },
        standard: { usd: 10, euro: 10, gbp: 9, cad: 14, aud: 14, brl: 45, mxn: 200, inr: 750, jpy: 1100 },
        pro: { usd: 16, euro: 16, gbp: 14, cad: 22, aud: 22, brl: 75, mxn: 320, inr: 1200, jpy: 1800 },
        enterprise: { usd: 38, euro: 38, gbp: 33, cad: 51, aud: 51, brl: 178, mxn: 760, inr: 2850, jpy: 4200 }
      },
      twoYearly: {
        basic: { usd: 7, euro: 7, gbp: 6, cad: 9, aud: 9, brl: 29, mxn: 140, inr: 525, jpy: 750 },
        standard: { usd: 8, euro: 8, gbp: 7, cad: 11, aud: 11, brl: 37, mxn: 160, inr: 600, jpy: 900 },
        pro: { usd: 14, euro: 14, gbp: 12, cad: 18, aud: 18, brl: 62, mxn: 280, inr: 1050, jpy: 1600 },
        enterprise: { usd: 32, euro: 32, gbp: 28, cad: 43, aud: 43, brl: 148, mxn: 640, inr: 2400, jpy: 3600 }
      }
    };
  }
}
